import React from "react";
import {Nav,Navbar} from "react-bootstrap";
import './NavigationBar.css';
import Logo from '../img/Ali.png';

export  const NavigationBar = () => (
        <Navbar expand="lg">
                <Navbar.Brand href="/">
                    <img src={Logo} alt="logo" height={30}/>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ml-auto">
                        <Nav.Item><Nav.Link style={{color:"black"}} href="/">Anasayfa</Nav.Link></Nav.Item>
                        <Nav.Item><Nav.Link style={{color:"black"}} href="/sertifikalar">Sertifikalar</Nav.Link></Nav.Item>
                        <Nav.Item><Nav.Link style={{color:"black"}} href="/projeler">Projeler</Nav.Link></Nav.Item>
                        <Nav.Item><Nav.Link style={{color:"black"}} href="/ozgecmis">Özgeçmiş</Nav.Link></Nav.Item>
                    </Nav>
                </Navbar.Collapse>
                   </Navbar>
)